import React from 'react';
import { useIntl } from 'react-intl';

import Tooltip from '@atlaskit/tooltip/Tooltip';

import { LoadableAfterPaint, type LoadableType } from '@confluence/loadable';

import { reviewButtonMessages, ReviewButtonBase } from './ReviewButtonBase.tsx';
import type { ReviewButton } from './ReviewButton.tsx';

// Match the loaded button while keeping its implementation behind the dynamic import.
export function ReviewButtonPlaceholder(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<Tooltip
			content={formatMessage(reviewButtonMessages.reviewSuggestionsLabel)}
			position="left"
			delay={0}
		>
			<ReviewButtonBase isDisabled />
		</Tooltip>
	);
}

export const ReviewButtonLoader: LoadableType<React.ComponentProps<typeof ReviewButton>> =
	LoadableAfterPaint({
		loading: () => <ReviewButtonPlaceholder />,
		loader: async () =>
			(await import(/* webpackChunkName: "loadable-ReviewButton" */ './ReviewButton.tsx'))
				.ReviewButton,
	});
